import React from 'react';
import { PLUGIN_VERSION } from '@/helpers/plugin';

const TRIAL_URL =
  'https://accessibility.webyes.com/trial?plan=accessibility_pro_monthly' +
  '&utm_source=ScannerSidebar' +
  '&utm_medium=AccessibilityPlus' +
  '&utm_campaign=PluginSignups' +
  `&utm_content=${PLUGIN_VERSION}`;

export const Footer: React.FC = () => {
  const handleExploreClick = () => {
    window.open(TRIAL_URL, '_blank', 'noopener,noreferrer');
  };

  return (
    <div className="cy:bg-blue-800 cy:text-white cy:px-4 cy:py-3 cy:flex cy:items-center cy:gap-2 cy:flex-shrink-0">
      <div className="cy:flex-1">
        <p className="cy:m-0 cy:text-white" style={{ fontSize: '12px', fontWeight: 400, lineHeight: '140%' }}>
          WebYes gives you deeper insights into your website's accessibility issues
        </p>
      </div>

      <div className="cy:flex-shrink-0">
        <button
          onClick={handleExploreClick}
          className="cy:bg-white cy:text-blue-600 cy:hover:bg-gray-100 cy:px-3 cy:py-2 cy:flex cy:items-center cy:gap-1 cy:rounded-md cy:whitespace-nowrap cy:border-0 cy:cursor-pointer"
          style={{ fontSize: '14px', fontWeight: 600, lineHeight: '100%' }}
        >
          Explore now
        </button>
      </div>
    </div>
  );
};
